'use client'

import { Suspense } from 'react'
import Spline from '@splinetool/react-spline'

export function SplineScene({ scene, className, ...props }) {
  return (
    <div className={className} {...props}>
      <Suspense fallback={
        <div className="w-full h-full bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-400"></div>
        </div>
      }>
        <Spline scene={scene} />
      </Suspense>
    </div>
  )
}